export default __webpack_public_path__ + "static/media/love.394b026e.svg";